
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container">
  <error [error]="error"></error>
  <div class="row">
    <div class="col">
      <list-controls [search]="dartDeals.searchText" [limit]="dartDeals.pageSize" [page]="dartDeals.currentPage" [numPages]="dartDeals.maxPages" [totalCount]="dartDeals.filteredLength" (onChange)="dartDeals.onListControlsChange($event)">
        <button class="btn btn-primary" id="importDartDeal" importDartDeal [projectId]="workflowTargetInfo.projectId" targetSystem="daas" [CPQSource]="CPQSource" type="button" (closed)="importDartDealDialogClosed($event)" *ngIf="workflowTargetInfo.correctRole &amp;&amp; !POR496_2">{{ CPQSource ? 'Import deal from CPQ' : 'Import DART Deal' }}</button>
        <button class="btn btn-primary dropdown-toggle" data-toggle="dropdown" type="button" *ngIf="POR496_2">{{ CPQSource ? 'Import Devices' : 'Import Dart Devices' }}
          <div class="dropdown-menu dropdown-menu-right"><a class="btn btn-block btn-small" importDartDeal [projectId]="workflowTargetInfo.projectId" [targetSystem]="targetSystem" [CPQSource]="false" type="button" (closed)="importDartDealDialogClosed($event)">Import from DART Deal</a><a class="btn btn-block btn-small" importDartDeal [projectId]="workflowTargetInfo.projectId" [targetSystem]="targetSystem" [CPQSource]="true" type="button" (closed)="importDartDealDialogClosed($event)" *ngIf="POR723_TMC">Import deal from SAP CPQ</a><a class="btn btn-block btn-small" *privilege="'contract-administrator'" [uploadFileTo]="'/api/dartapi/import-daas-dart-deal-from-template'" [fileExtensions]="['xls', 'xlsx']" [params]="{projectId: projectId, targetSystem: targetSystem}" [title]="'Import Solution from Template'" (closed)="importDartDealDialogClosed($event)" [ngClass]="{'disabled': !isCurrentMaSuccess}"> Import from template file</a></div>
        </button>
      </list-controls>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="card-item">
        <div class="row">
          <div class="col-12">
            <h5>Devices on this project</h5>
            <div class="container pt-4" style="padding: 0 4.5rem;">
              <div class="row">
                <div class="form-group col-lg-6">
                  <div>Reseller Name</div>
                  <div class="border-bottom text-secondary">{{project?.resellerName}}&nbsp;</div>
                </div>
                <div class="form-group col-lg-6">
                  <div>Reseller BP ID</div>
                  <div class="border-bottom text-secondary">{{project?.resellerBpId}}&nbsp;</div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-lg-6">
                  <div>Customer Name</div>
                  <div class="border-bottom text-secondary">{{project?.customerName}}&nbsp;</div>
                </div>
                <div class="form-group col-lg-6">
                  <div>Customer BP ID</div>
                  <div class="border-bottom text-secondary">{{project?.customerBpId}}&nbsp;</div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-lg-6">
                  <div>Unique ID</div>
                  <div class="border-bottom text-secondary">{{project?.uniqueId}}&nbsp;</div>
                </div>
                <div class="form-group col-lg-6">
                  <div>Master Opportunity ID</div>
                  <div class="border-bottom text-secondary">{{project?.opportunityId}}&nbsp;</div>
                </div>
              </div>
              <div class="row" *ngIf="enableGlobalDeals">
                <div class="form-group col-lg-6">
                  <div>Global Opportunity ID</div>
                  <div class="border-bottom text-secondary">{{globalDealSettings?.globalOpportunityId}}&nbsp;</div>
                </div>
              </div>
              <div class="row my-3">
                <div class="col-12">
                  <property-container>
                    <property-item>Total: {{ project?.totalDevices | number:0 }}</property-item>
                  </property-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngFor="let dartDeal of dartDeals.filtered">
    <div class="col">
      <div class="card-item">
        <div class="d-flex justify-content-between mt-3">
          <h4>{{ dartDeal.dealKey }}<span class="badge badge-secondary ml-2" *ngIf="dartDeal.quicksilver">QS</span></h4>
          <div *ngIf="workflowTargetInfo.correctRole">
            <button class="btn btn-link mr-3" (click)="remove(dartDeal.id)" *ngIf="!dartDeal.asset.planned &amp;&amp; !dartDeal.accessory.planned &amp;&amp; !dartDeal.software.planned">Remove</button>
            <button class="btn btn-outline-primary" (click)="manageDevices(dartDeal)">Manage devices</button>
          </div>
        </div>
        <div class="container" style="padding: 1rem 4.5rem 0;">
          <div class="row">
            <div class="col-3">Localization Codes:</div>
            <div class="table table-borderless col-9 p-0 m-0" *ngIf="dartDeal.salesOrg.length &gt; 0">
              <tr *ngFor="let localizationtionCode of dartDeal.salesOrg">
                <td class="pl-0 pt-0 font-weight-bold">{{localizationtionCode.localizationCode}}</td>
                <td class="pt-0 text-muted font-italic" style="font-size: 12px; padding-top: 0.3em !important; padding-left: 0 !important;">{{localizationtionCode.localizationDescription}}</td>
              </tr>
            </div><span *ngIf="dartDeal.salesOrg.length === 0">No localization Codes</span>
          </div>
        </div>
        <div class="container" style="padding: 1rem 4.5rem 0;">
          <div class="row">
            <div class="col-12">
              <div class="table table-borderless table-responsive">
                <thead class="text-center">
                  <tr>
                    <th class="border-bottom">&nbsp;</th>
                    <th class="border-bottom">Total</th>
                    <th class="border-bottom">Solution Count</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Devices</td>
                    <td class="text-center">{{ dartDeal.asset.total }}</td>
                    <td class="text-center">{{ dartDeal.asset.solutionCount }}</td>
                  </tr>
                  <tr>
                    <td>Accessories</td>
                    <td class="text-center">{{ dartDeal.accessory.total }}</td>
                    <td class="text-center">{{ dartDeal.accessory.solutionCount }}</td>
                  </tr>
                  <tr>
                    <td>Software Solutions</td>
                    <td class="text-center">{{ dartDeal.software.total }}</td>
                    <td class="text-center">{{ dartDeal.software.solutionCount }}</td>
                  </tr>
                </tbody>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>